import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["markedForDestruction"];

  // Most of the logic dealing with accounting categories is actually in receipt-form-controller, since
  // we reload that form via Ajax upon changes to categories as well as other actions. So this controller currently
  // only handles deletion of categorizations. Mainly, it's because the addNewCategory method in receipt-form-controller.js
  // calls updateFormWithAjax with a parameter that we can't just move everything related to categories into this controller.
  // If we can send an argument along with the event (which is actually simple to do) we could consolidate it all into this file. 

  markForDestruction() {
    this.markedForDestructionTarget.value = true;
    // And then we need to tell the receipts controller to update the form via ajax
    this.element.closest('form').parentNode.dispatchEvent(new Event('reload_w_ajax', { 'bubbles': false }))
  }
}